$ = require 'jquery'
actionFilterFromString = require 'app/scripts/lib/util/action-filter-from-string'
ApiAjax = require 'app/scripts/network/api-ajax'
ApiPromise = require 'app/scripts/network/api-promise'
Accounts = require 'app/common/lib/accounts'
Auth = require 'app/scripts/db/auth'
{ BoardBackgroundList } = require 'app/scripts/models/collections/BoardBackgroundList'
BoardStarList = require 'app/scripts/models/collections/board-star-list'
{ CustomEmojiList } = require 'app/scripts/models/collections/CustomEmojiList'
CustomStickerList = require 'app/scripts/models/collections/custom-sticker-list'
DesktopNotification = require 'app/scripts/lib/desktop-notification'
Enterprise = require 'app/scripts/models/enterprise'
Language = require('@trello/locale')
LimitMixin = require 'app/scripts/lib/limit-mixin'
LoginList = require 'app/scripts/models/collections/login-list'
MemberFeatures = require 'app/scripts/data/member-features'
{ getUnreadNotifications } = require 'app/scripts/models/internal/member-helper'
moment = require 'moment'
ModelWithPreferences = require 'app/scripts/models/internal/model-with-preferences'
Notification = require 'app/scripts/models/notification'
NotificationFilterState = require 'app/scripts/view-models/notification-filter-state'
NotificationsSeenState = require 'app/scripts/view-models/notifications-seen-state'
NonPublicMixin = require 'app/scripts/lib/non-public-mixin'
Payloads = require 'app/scripts/network/payloads'
PluginDataList = require 'app/scripts/models/collections/plugin-data-list'
Promise = require 'bluebird'
SavedSearchList = require 'app/scripts/models/collections/saved-search-list'
Storage = require 'app/scripts/lib/storage'
Time = require 'app/scripts/lib/time'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'

# Default new accounts to a simpler detail view
HIDE_DETAILS_DEFAULT_DATE = new Date(2016, 8, 21)

ACCOUNT_TRANSFER_BANNER_MESSAGE_NAME = "AccountTransferRequired"

class Member extends ModelWithPreferences
  mixin LimitMixin, NonPublicMixin, @
  EDITING_AUTO_CLEAR_MS = 10000
  typeName: 'Member'
  nameAttr: 'fullName'
  urlRoot: '/1/members'
  nonPublicFields: [
    'avatarHash'
    'avatarUrl'
    'fullName'
    'initials'
  ]
  nonPublicKey: 'nonPublic'
  loadingNonPublicFields: false

  defaults:
    notificationsCount: {}

  initialize: ->
    super

    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    if Auth.isMe(@)
      @destruct [
        @boardStarList = new BoardStarList([], { member: @ }).syncSubModels(@, 'boardStars')
        @savedSearchList = new SavedSearchList([], { member: @ }).syncSubModels(@, 'savedSearches')
        @customStickerList = new CustomStickerList([], { member: @ }).syncSubModels(@, 'customStickers')
        @boardBackgroundList = new BoardBackgroundList([], { member: @ }).syncSubModels(@, 'boardBackgrounds')
        @customEmojiList = new CustomEmojiList([], { member: @ }).syncSubModels(@, 'customEmoji')
        @loginList = new LoginList([], { member: @ }).syncSubModels(@, 'logins')
      ]

      if @isFeatureEnabled('customEmoji')
        ModelLoader.loadMemberCustomEmoji(@id).done()

      @listenTo @modelCache, 'add:Notification', _.debounce(@ensureGroup, 500)
      @listenTo @modelCache, 'rpc:add:Notification', @updateNotificationCount('add')
      @listenTo @modelCache, 'change:Notification:unread', @updateNotificationCount('change')
      @listenTo @modelCache, 'rpc:remove:Notification', @updateNotificationCount('delete')
      @initializeNotifications()

    @listenTo @, 'change:editing', (member) =>
      @modelCache.get('Card', member.get('editing')?.idCard)?.updateEditing(member)

    # Privacy
    @listenTo @, 'change:nonPublicAvailable', @nonPublicAvailableChanged
    @listenTo @, 'change:nonPublicModified', @nonPublicModifiedChanged

    return

  @lazy
    boardList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      BoardList = require 'app/scripts/models/collections/board-list'
      new BoardList().syncModel(@, 'idBoards')
    enterpriseList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      EnterpriseList = require 'app/scripts/models/collections/enterprise-list'
      new EnterpriseList()
      .syncModel @, 'enterprises',
        fxGetIds: (enterprises) ->
          (enterprises || [])
            .filter (enterprise) -> enterprise.isRealEnterprise != false
            .map (enterprise) -> enterprise.id
    organizationList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      OrganizationList = require 'app/scripts/models/collections/organization-list'
      new OrganizationList().syncModel(@, 'idOrganizations')
    pluginDataList: ->
      new PluginDataList([], {
        scopeModel: @
      }).syncCache @modelCache, [], (pluginData) =>
        pluginData.get('idModel') == @id && pluginData.get('scope') == 'member'

  isVisibleAction: (action) ->
    @_actionFilter ?= actionFilterFromString(Payloads.memberActions)
    @_actionFilter(action)

  isLoggedIn: ->
    !@get('notLoggedIn')

  getMembershipData: (model) ->
    admins = model.adminList.models
    isMe = Auth.isMe(@)
    me = Auth.me()

    # logic
    isOneOtherAdmin = _.some(admins, (admin) => admin.id != @id)
    isMoreThanOneAdmin = admins.length > 1
    isMoreThanOneMember = model.memberList.length > 1
    membership = model.getMembershipFor(@)
    memberIsAdmin = model.getExplicitMemberType(@) == 'admin' || membership?.memberType == 'admin'
    memberIsObserver = model.getExplicitMemberType(@) == 'observer' || membership?.memberType == 'observer'
    memberIsNormal = !(memberIsAdmin || memberIsObserver)
    memberIsVirtual = model.isVirtual(@)
    isAdmin = model.owned() # this checks whether the current member (me) is an admin
    notOrg = model.getExplicitMemberType(@) != 'org'

    # perms
    canChangeRole = isAdmin
    canMakeMember = !memberIsNormal && isOneOtherAdmin && isAdmin
    canMakeObserver = !memberIsObserver && isOneOtherAdmin && isAdmin
    canMakeAdmin = !memberIsAdmin && isAdmin

    # For any model, an admin can always remove any member and a member can always
    # remove himself as long as there is more than one member and another admin remaining.
    # For models except orgs, a member can be removed if the current member (me)
    # can invite members to the board and has equal or higher permissions to
    # the member he's removing.
    canRemove = isMoreThanOneMember && ((isOneOtherAdmin && (isAdmin || isMe)) ||
      (!isMe && notOrg && model.canInviteMembers?() &&
      model.compareMemberType?(me, @) >= 0))
    canDeactivate = canRemove && (model.typeName == 'Organization' && isAdmin && !model.isDeactivated(@) && !memberIsVirtual)

    return {
      isMe
      canRemove
      canDeactivate
      canChangeRole
      memberIsAdmin
      memberIsObserver
      memberIsNormal
      memberIsVirtual
      canMakeMember
      canMakeObserver
      canMakeAdmin
      isMoreThanOneAdmin
      isMoreThanOneMember
    }

  canAddBoardsTo: (org) ->
    org.getMembershipFor(@)? ||
    (org.isEnterprise() && org.getEnterprise()?.isAdmin(@))

  isDismissed: (name) ->
    name in (@get('oneTimeMessagesDismissed') ? [])

  dismiss: (name, next) ->
    return next?() if @isDismissed(name)
    @addToSet('oneTimeMessagesDismissed', name, next)

  recordDismissed: (name) ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: name
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  dismissAd: (adId) ->
    @recordDismissed "ad-#{adId}"

  dismissSurveyById: (surveyId) ->
    @recordDismissed "survey-#{surveyId}"

  getDismissedAd: (adId) ->
    messagesDismissed = @get 'messagesDismissed' ? []
    _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == "ad-#{adId}"

  getDismissedSurveys: ->
    messagesDismissed = @get 'messagesDismissed' ? []
    # Survey messages dismissed match format "survey-{SURVEY_ID}"
    _.filter messagesDismissed, (msg) -> msg.name.match(/^survey-.*$/)

  isAdDismissed: (adId) ->
    dismissedAd = @getDismissedAd(adId)
    if dismissedAd then moment().diff(moment(dismissedAd.lastDismissed), 'days') <= 14 else false

  setDateFirstSawHighlights: ->
    @recordDismissed "feedback-card-home-page-internal"

  getDateFirstSawHighlights: ->
    messagesDismissed = @get 'messagesDismissed' ? []
    feedbackCard = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == 'feedback-card-home-page-internal'
    if !feedbackCard
      return null
    else
      return feedbackCard.lastDismissed

  shouldShowFeedbackCard: ->
    if @isDismissed('homeFeedbackOrientationCard')
      return false

    messagesDismissed = @get 'messagesDismissed' ? []
    feedbackCard = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == 'feedback-card-home-page-internal'
    days = 0
    if feedbackCard
      days = moment().diff(moment(feedbackCard.lastDismissed), 'days')
    return days > 7

  dismissLanguageBannerFor: (locale, next) ->
    @dismiss "new-lang-#{locale}", next

  shouldShowNewLanguageBannerFor: (locale) ->
    locale = Language.normalizeLocale(locale)
    !@isDismissed("new-lang-#{locale}") &&
    @getLocale() != locale &&
    Language.currentLocale != locale &&
    Language.getMostPreferred([@getLocale(), locale]) == locale

  toggleSubscribeOnComment: ->
    @dismissAd('subscribeOnComment')

  isSubscribeOnCommentEnabled: ->
    dismissalCount = @getDismissedAd('subscribeOnComment')?.count ? 0
    # Overloading the dismissal count since messagesDismissed
    # does not allow for deletion.
    dismissalCount % 2 == 0

  hasDismissedSince: (name, period, count) ->
    messagesDismissed = @get 'messagesDismissed' ? []
    message = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == name

    if message
      return moment().diff(message.lastDismissed, period) < count

    return false

  shouldShowEnterpriseBannerFor: (idEnterprise) ->
    # don't show the banner if we have checked or shown the banner in the last
    # 24 hours, or if the user dismissed the banner in the past 30 days

    # This is a performance and UX optimization as we don't want to perform the license
    # count request on every page load (would slow down all page loads), so it's loaded
    # asynchronously. This leads to an experience where the content on the page will 'jump'
    # when the banner is loaded in, so we want to avoid that happening more than once a day.
    return false if @hasDismissedSince("enterprise-license-banner-shown-#{idEnterprise}", 'hours', 24)
    return false if @hasDismissedSince("enterprise-license-banner-checked-#{idEnterprise}", 'hours', 24)
    return false if @hasDismissedSince("enterprise-license-banner-#{idEnterprise}", 'days', 30)

    return true

  recordEnterpriseBannerCheckedFor: (idEnterprise) ->
    @recordDismissed "enterprise-license-banner-checked-#{idEnterprise}"

  recordEnterpriseBannerShownFor: (idEnterprise) ->
    @recordDismissed "enterprise-license-banner-shown-#{idEnterprise}"

  dismissEnterpriseBannerFor: (idEnterprise) ->
    @recordDismissed "enterprise-license-banner-#{idEnterprise}"

  dismissAccountTransferBanner: (next) ->
    @dismiss ACCOUNT_TRANSFER_BANNER_MESSAGE_NAME, next

  isAccountTransferBannerDismissed: ->
    @isDismissed ACCOUNT_TRANSFER_BANNER_MESSAGE_NAME

  owned: ->
    Auth.isMe(@)

  prefNames: ['minutesBetweenSummaries']

  getLocale: ->
    if @getPref('locale')
      Language.normalizeLocale @getPref('locale')
    else
      'en'

  getLocales: ->
    if @isLoggedIn()
      [@getLocale(), 'en']
    else
      Language.getPreferredLanguages()

  getMemberViewTitle: ->
    username = @get('username')
    fullName = @get('fullName')
    viewTitle = if username == fullName then "@#{username}" else "#{fullName} (#{username})"
    return viewTitle

  toggleColorBlindMode: ->
    if @get('prefs')?
      if @get('prefs').colorBlind
        @setPref('colorBlind', false).save()
      else
        @setPref('colorBlind', true).save()
    return

  addCurrentBoardToOrgs: (currentBoard, organizations) ->
    if organizations[currentBoard.idOrganization]
      organizations[currentBoard.idOrganization].boards.unshift(currentBoard)
    else
      organizations[currentBoard.idOrganization] =
        boards: [currentBoard]
        displayName: @modelCache.get('Organization', currentBoard.idOrganization)?.get('displayName')

  getOpenBoardsByOrg: (editable, currentBoard) ->
    organizations = {}

    for board in @boardList.models when board.isOpen()
      # Do this properly with board.editable when we get memberships working better
      if editable && board.get('myPermLevel') == 'observer'
        continue
      boardData = board.toJSON()

      # It's possible to be on a board that you can see the
      # idOrganization for even though you couldn't see the team.
      idOrg =
        if board.getOrganization()?
          boardData.idOrganization
        else
          ""

      organizations[idOrg] ?=
        boards: []
        displayName: (if idOrg == '' then l('member boards.boards') else @modelCache.get('Organization', idOrg)?.get('displayName'))

      organizations[idOrg].boards.push(boardData)

    if currentBoard
      @addCurrentBoardToOrgs(currentBoard, organizations)

    idOrgsSorted = _.sortBy _.keys(organizations), (idOrg) ->
      if idOrg == ''
        ''
      else
        organizations[idOrg].displayName

    organizations[idOrg] for idOrg in idOrgsSorted

  getOpenBoardsInEnterpriseByOrg: (editable, idEnterprise) ->
    organizations = {}

    for board in @boardList.models when board.isOpen()
      # Do this properly with board.editable when we get memberships working better
      if editable && board.get('myPermLevel') == 'observer'
        continue
      boardData = board.toJSON()

      # It's possible to be on a board that you can see the
      # idOrganization for even though you couldn't see the team.
      org = board.getOrganization()
      idOrg =
        if org?.get('idEnterprise') == idEnterprise
          boardData.idOrganization
        else
          false

      continue if !idOrg

      organizations[idOrg] ?=
        boards: []
        displayName: (if idOrg == '' then l('member boards.boards') else @modelCache.get('Organization', idOrg)?.get('displayName'))

      organizations[idOrg].boards.push(boardData)

    idOrgsSorted = _.sortBy _.keys(organizations), (idOrg) ->
      if idOrg == ''
        ''
      else
        organizations[idOrg].displayName

    organizations[idOrg] for idOrg in idOrgsSorted


  getSortedOrgs: ->
    _.clone(@organizationList.models).sort (a, b) ->
      a.get('displayName').localeCompare b.get('displayName')

  isFeatureEnabled: (feature) ->
    MemberFeatures.isFeatureEnabled(feature, @get('products'))

  isGold: ->
    MemberFeatures.hasProduct(@get('products'))

  isInAnyBCOrganization: ->
    @organizationList.any((org) -> org.isPremium())

  getBillingStrategy: (product) ->
    flatRate: true

  hasMemberAccount: ->
    Accounts.hasAccount(@get('paidAccount')?.standing)

  hasMemberOrOrgAccount: ->
    @hasMemberAccount() || @organizationList.any((org) -> org.hasAccount())

  allCustomEmoji: ->
    allEmoji = {}
    if @isFeatureEnabled('customEmoji')
      for emoji in @customEmojiList.models
        allEmoji[emoji.get('name')] = emoji.get('url')

    allEmoji

  toJSON: (opts = {}) ->
    data = super
    if opts.hasPassword
      data.hasPassword = ('password' in data.loginTypes)

    data.accountStanding = Accounts.standingName(@get('paidAccount')?.standing)

    data.viewTitle = @getMemberViewTitle()

    @handleNonPublicFields data

  editing: (msg = {}) ->
    if _.isEqual(msg, @lastMessage)
      return

    @lastMessage = msg

    clearTimeout @clearLastTimeout

    @clearLastTimeout = @setTimeout =>
      @lastMessage = null
    , (EDITING_AUTO_CLEAR_MS / 2)

    if Auth.isLoggedIn()
      ApiAjax
        url: "#{@urlRoot}/#{@id}/editing"
        type: 'post'
        background: true
        data: _.clone(msg)

  removeMembershipConfirmationKey: (model) ->
    isOrg = model.typeName == 'Organization'
    return if Auth.isMe(@)
      if isOrg
        'leave org'
      else
        'leave board'
    else
      if isOrg
        'remove member from org'
      else if model.isDeactivated(@)
        'remove deactivated member from board'
      else
        'remove member from board'

  unreadNotifications: ->
    getUnreadNotifications(@, @modelCache, @notificationsSeenState)

  setNotifications: ({ notifications, setFn, errorFn, data }) ->
    _.forEach notifications, setFn

    ApiAjax
      url: '/1/notifications/all/read'
      type: 'post'
      retry: false
      data: data
      error: ->
        _.forEach notifications, errorFn

  clearAllNotifications: ->
    unreadNotifications = @modelCache.all('Notification')
      .filter (notification) -> notification.get('unread')
    dateRead = new Date()
    oldCount = @get('notificationsCount')

    @setNotifications
      notifications: unreadNotifications
      setFn: (notif) ->
        notif.set
          dateRead: dateRead
          unread: false
      errorFn: (notif, i) =>
        if i == 0
          @set 'notificationsCount', oldCount
        notif.set
          dateRead: null
          unread: true

    @set 'notificationsCount', {}

    return

  initializeDesktopNotifications: ->
    @idLastDesktopNotification = _.chain(@modelCache.all('Notification'))
      .pluck("id")
      .compact()
      .sort()
      .last()
      .value() ? ""

    @listenTo @modelCache, 'add:Notification', @showDesktopNotification

  initializeNotifications: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    if !Auth.isLoggedIn()
      return
    myId = @get('id')
    filterState = @notificationFilterState = new NotificationFilterState(myId)
    username = @get('username')
    pageSize = Notification.PAGE_SIZE

    initialLoad =
      if filterState.getVisibility() == filterState.VISIBILITY_ALL
        ModelLoader.loadMoreNotificationGroupData(pageSize)
      else
        ModelLoader.loadMoreUnreadNotifications(pageSize)
    @loadNotificationsCount().then =>
      initialLoad.then =>
        @initializeDesktopNotifications()

    @notificationsSeenState = new NotificationsSeenState @

  loadNotificationsCount: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    ModelLoader
      .loadMemberNotificationsCount()
      .then (notificationsCount) =>
        @set 'notificationsCount', notificationsCount

  # Ensures that all notifications in the Model Cache have an appropriate group
  ensureGroup: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    idCards = @modelCache.all('Notification')
    .map (notification) ->
      notification.get('data')?.card?.id
    .filter (idCard) -> idCard?
    idCards = _.uniq(idCards)

    idCardGroups = @modelCache.all('NotificationGroup')
    .map (group) -> group.get('id')
    .filter (idGroup) -> idGroup.startsWith('Card:')
    .map (idGroup) -> idGroup.replace('Card:', '')

    needToFetch = _.difference(idCards, idCardGroups)
    if needToFetch.length > 0
      ModelLoader.loadNotificationGroups(needToFetch)

  updateNotificationCount: (eventType) => (notification) =>
    if notification?
      idCard = notification.get('data')?.card?.id
      notificationsCount = _.clone @get 'notificationsCount'
      notifType =
        if idCard?
          "Card:#{idCard}"
        else
          "Notification:#{notification.get('id')}"

      notificationsCount[notifType] ?= 0
      isUnread = notification.get 'unread'
      switch eventType
        when "add"
          isNew = !@modelCache.all('Notification').some (n) ->
            n.get('id') > notification.get('id')
          if isUnread && isNew
            notificationsCount[notifType]++
          else if !isNew
            notificationsCount[notifType]--
        when "change"
          if isUnread
            notificationsCount[notifType]++
          else
            notificationsCount[notifType]--
        when "delete"
          if isUnread
            notificationsCount[notifType]--

      @set 'notificationsCount', _.pick(notificationsCount, _.identity)

  showDesktopNotification: (notification) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'

    if !DesktopNotification.enabled()
      return

    # Only do a desktop notification if this notification is *newer* than the
    # last one we've seen
    if notification.id <= @idLastDesktopNotification
      return

    @idLastDesktopNotification = notification.id

    Promise.try ->
      # It's possible that we've just re-connected our websocket and we're
      # receiving old notifications.  This commonly happens when a laptop
      # wakes up.
      delta = Date.now() - Time.serverToClient(notification.get('date'))
      if delta < Util.getMs(minutes: 1)
        # The notification just happened, so consider the notification to
        # be current
        notification
      else
        # The notification happened a while ago, so it's possible that
        # it's actually been read.  Fetch the latest version of the
        # notification
        ModelLoader.loadNotification(notification.id)
    .then (latestNotification) ->
      if latestNotification.get('unread')
        new DesktopNotification(latestNotification)
    .done()

  getNotificationFilterState: -> @notificationFilterState

  getMobileTempPassword: (next) ->
    ApiAjax
      url: '/1/members/me/loginToken'
      type: 'post'
      data:
        mode: 'password'
      success: (data) -> next(data.password)
    return

  maxFileSize: ->
    if @isFeatureEnabled('largeAttachments')
      250 * 1024 * 1024
    else
      10 * 1024 * 1024

  canUploadAttachment: (file) ->
    return file.size < @maxFileSize()

  accountNewerThan: (date) ->
    Util.idToDate(@id) > date

  isNewMember: ->
    moment().diff(moment(Util.idToDate(@id)), 'days') < 7

  getShowDetails: ->
    Storage.get('showDetails') ? if @accountNewerThan(HIDE_DETAILS_DEFAULT_DATE) then false else true

  setShowDetails: (value) ->
    Storage.set('showDetails', value)

  enterpriseWithRequiredConversion: ->
    # If the user already belongs to an enterprise, then they already
    # are an enterprise member (unless it's an atlOrg enterprise)
    idEnterprise = @get('idEnterprise')
    if idEnterprise
      enterprise = @modelCache.get('Enterprise', idEnterprise)
      if enterprise?.isRealEnterprise()
        return
    org = @organizationList.find (org) ->
      org.get('idEnterprise')? \
      && org.getEnterprise()? \
      && org.getEnterprise().get('prefs')?.mandatoryTransferDate \
      && !org.getEnterprise().get('prefs')?.ssoOnly \
      && org.getEnterprise().get('enterpriseDomains').length > 0
    if org?
      org.getEnterprise()

  getEnterprise: ->
    @modelCache.get('Enterprise', @get('idEnterprise'))

  missedTransferDate: ->
    @get('missedTransferDate')

  hasBCPowerUps: ->
    @organizationList.any((org) -> org.isFeatureEnabled('plugins'))

  # Get the number of power-ups a user is allowed to turn on for a board
  getPowerUpsLimit: ->
    # All boards can enable 1 power-up
    # Gold members can enable 3 power-ups on all boards
    # BC members can enable unlimited power-ups on all boards
    if @hasBCPowerUps()
      Infinity
    else if @isFeatureEnabled('threePlugins')
      3
    else
      1

  isManagedEntMember: ->
    @get('confirmed') && @get('idEnterprise')

  isManagedEntMemberOf: (idEnterprise) ->
    @get('confirmed') && @get('idEnterprise') && (@get('idEnterprise') == idEnterprise)

  isEnterpriseAdmin: ->
    @get('confirmed') && @get('idEnterprisesAdmin')?.length > 0

  isEnterpriseAdminOf: (enterprise) ->
    @isEnterpriseAdmin() && @get('idEnterprisesAdmin').indexOf(enterprise.id) >= 0

  isSSOOnly: ->
    idEnterprise = @get('idEnterprise')

    if idEnterprise && (enterprise = @modelCache.get('Enterprise', idEnterprise))?
      enterprise.get('prefs').ssoOnly
    else
      false

  shouldShowMarketingOptIn: ->
    # Show marketing opt in survey if the account is confirmed, more than
    # 3 days old, and hasn't previously set marketingOptIn

    @get('confirmed') \
      && (new Date() - Util.idToDate(@id)) > Util.getMs(days: 3) \
      && !@get('marketingOptIn')?.date

  setMarketingOptIn: (optedIn) ->
    @update "marketingOptIn/optedIn", optedIn, ->

  setPluginData: (idPlugin, visibility, data) ->
    @pluginDataList.upsert(idPlugin, visibility, data)

  getPluginData: (idPlugin) ->
    @pluginDataList.dataForPlugin(idPlugin)

  clearPluginData: (idPlugin) ->
    @pluginDataList.for(idPlugin, 'private')?.destroy()

  snoopPluginData: (idPlugin) ->
    memberPluginData = @pluginDataList.snoopDataForPlugin(idPlugin)

  fetchEnterpriseUserType: (enterpriseId) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadMemberEnterpriseUserType(enterpriseId, @get('id'))

  fetchEnterpriseActive: (enterpriseId) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.loadMemberEnterpriseActive(enterpriseId, @get('id'))

  shouldShowNoticeOfTosChange: ->
    # Show notice of ToS change if the user's account was created before
    # November 1, 2018 and the user has not already dismissed the message by
    # clicking "I Agree"
    messagesDismissed = @get 'messagesDismissed' ? []
    new Date(2018, 10, 1) > Util.idToDate(@id) \
      && !(_.contains (_.pluck messagesDismissed, 'name'), '1-nov-2018-tos-change-accepted')

  agreeToAndDismissTosChange: ->
    @recordDismissed "1-nov-2018-tos-change-accepted"

  # Privacy
  loadNonPublicFields: =>
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    if !@loadingNonPublicFields
      @loadingNonPublicFields = true
      ModelLoader
        .loadMemberNonPublicFields(@get 'id')
        .then =>
          @nonPublicFields.forEach (field) =>
            @trigger "change:#{field}"
        .finally =>
          @loadingNonPublicFields = false

    return

  nonPublicAvailableChanged: ->
    nonPublicAvailable = @get 'nonPublicAvailable'
    nonPublic = @get(@nonPublicKey)

    # We have received a hint that there's a change in non public fields so
    # let's fetch them to get the latest, but only if we don't have any already
    if nonPublicAvailable && !nonPublic?
      @loadNonPublicFields()

    # The hint is false, this means non public field information is no longer
    # available, we need to clear any data on this member model to clear any
    # cached sensitive information.
    else if !nonPublicAvailable
      @unset @nonPublicKey

    return

  nonPublicModifiedChanged: ->
    nonPublicModified = @get 'nonPublicModified'

    # We have received a hint that there's a change in non public fields so
    # let's fetch them to get the latest regardless of what we already have
    if nonPublicModified
      @loadNonPublicFields()

      # It's important to unset nonPublicModified so that it will cause
      # a re-trigger of the change event again, even if it stays as true
      @unset 'nonPublicModified', silent: true

    return

  shouldShowEnterpriseDeprovisioningBannerFor: (idEnterprise) ->
    # don't show the banner if we have checked or shown the banner in the last
    # hour, or if the user dismissed the banner in the past 24 hours
    return false if @hasDismissedSince("enterprise-deprovisioning-banner-shown-#{idEnterprise}", 'hours', 1)
    return false if @hasDismissedSince("enterprise-deprovisioning-banner-checked-#{idEnterprise}", 'hours', 1)
    return false if @hasDismissedSince("enterprise-deprovisioning-banner-#{idEnterprise}", 'hours', 24)

    return true

  recordEnterpriseDeprovisioningBannerCheckedFor: (idEnterprise) ->
    @recordDismissed "enterprise-deprovisioning-banner-checked-#{idEnterprise}"

  recordEnterpriseDeprovisioningBannerShownFor: (idEnterprise) ->
    @recordDismissed "enterprise-deprovisioning-banner-shown-#{idEnterprise}"

  dismissEnterpriseDeprovisioningBannerFor: (idEnterprise) ->
    @recordDismissed "enterprise-deprovisioning-banner-#{idEnterprise}"

module.exports = Member
